
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import AnforderungenDetail from '@/components/Anforderungen/AnforderungenDetail.vue';
    import Anforderung from '@/types/Anforderung';
    import { LoadAnforderungenPayload, AnforderungenFilter } from '@/store/anforderungen';
    import { DataTableHeaders } from '@/types';

    @Component({
        components: {
            AnforderungenDetail,
        },
        computed: {
            ...mapState('anforderungen', ['anforderungen', 'dialogs', 'loaders']),
        },
        methods: {
            ...mapActions('anforderungen', ['loadAnforderungen', 'updateAnforderungen']),
            ...mapMutations('anforderungen', ['setDialogsDetail']),
        },
    })
    export default class Anforderungen extends Vue {
        public loadAnforderungen!: (payload?: LoadAnforderungenPayload) => void;
        public setDialogsDetail!: (visible: boolean) => void;

        public anforderung = new Anforderung();
        public search = '';

        public filter: AnforderungenFilter = {
            gueltig: 'j',
        };

        public get headers(): DataTableHeaders<Anforderung> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Bezeichnung', value: 'bezeichnung' },
                { text: 'Dauer', value: 'dauer' },
                { text: 'Gültig', value: 'gueltig' },
            ];
        }

        public mounted(): void {
            this.loadAnforderungen();
        }

        public onChangeFilter(): void {
            this.loadAnforderungen({ filter: this.filter });
        }

        public onClickEdit(anforderung: Anforderung): void {
            this.anforderung = { ...anforderung };
            this.setDialogsDetail(true);
        }

        public onClickNew(): void {
            this.anforderung = new Anforderung();
            this.setDialogsDetail(true);
        }
    }
